import React from 'react';
import UpArrow from 'material-ui/svg-icons/navigation/arrow-upward';
import DownArrow from 'material-ui/svg-icons/navigation/arrow-downward';

const TableHeaderColumn = ({
  children,
  sort,
  sortName,
  className,
  onClick,
  ...rest
}) => (
  <div
    className={`table-header-column ${className || ''}`}
    {...rest}
    onClick={() => {
      if (onClick) {
        onClick({ [sortName]: sort ? (sort *= -1) : 1 });
      }
    }}
  >
    <p style={{ display: 'inline-block', verticalAlign: 'top' }}>
      {[children]}
    </p>
    {sort === 1 && <DownArrow />}
    {sort === -1 && <UpArrow />}
  </div>
);

export default TableHeaderColumn;



// WEBPACK FOOTER //
// ./src/components/Table/TableHeaderColumn/index.jsx